export const ActionsAdr = {
    add: 'add',
    edit: 'edit',
    general: 'general'
};
